import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import './FullScreenPopup.css'

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const FullScreenPopup = ({
    open,
    handleClose,
    children,
    modaltitle,
    className,
    disableEnforceFocus = false,
    inline = false,
}) => {
    const classes = useStyles()
    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [children])
    if (inline) {
        return <div className={`fullScreenPopupPage ${className || ''}`}>{children}</div>
    }

    return (
        <div>
            <Dialog
                fullScreen
                className={`fullScreenPopup ${className}`}
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                disableEnforceFocus
            >
                <AppBar className={classes.appBar}>
                    <Toolbar className="fspToolbar">
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {modaltitle}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className="modalChildren">{children}</div>
            </Dialog>
        </div>
    )
}

export default FullScreenPopup
